import {
  Eye,
  PlusCircle,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AddExemptedProducts from "./AddExemptedProducts";
import ViewExemptedProducts from "./ViewExemptedProducts";
import { API_BASE_URL } from "../../Config";
import axios from "axios";
import Swal from "sweetalert2";
import SpinLoader from "../loader/SpinLoader";

const Rewards = () => {
  const [formData, setFormData] = useState({
    Name: "",
    StartFrom: "",
    ExpiresOn: "",
    RatePerAmount: "",
    RedeemValue: "",
    MinPoints: "",
    MaxRedeemPercent: "",
    PointExpiryDays: "",
    MinOrderAmount: "",
    RewardType: "1",
    IsActive: 1,
  });

  const [userDataSession, setUserDataSession] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      navigate("/");
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [exemptedItems, setExemptedItems] = useState([]);
  const orgId = userDataSession?.OrgId;

  const [ruleId, setRuleId] = useState(null);

  const fetchRewardRule = async () => {
    setDataLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}Settings/getRewardRules?OrgId=${orgId}`,
      );

      if (response.data.Status && response.data.ResultData.length > 0) {
        const rule = response.data.ResultData[0];
        setRuleId(rule?.Id);
        setFormData({
          Name: rule?.Name || "",
          StartFrom: rule?.StartFrom ? rule?.StartFrom.split("T")[0] : "",
          ExpiresOn: rule?.ExpiresOn ? rule?.ExpiresOn.split("T")[0] : "",
          RatePerAmount: rule?.RatePerAmount,
          RedeemValue: rule?.RedeemValue,
          MinPoints: rule?.MinPoints,
          MaxRedeemPercent: rule?.MaxRedeemPercent,
          PointExpiryDays: rule?.PointExpiryDays,
          MinOrderAmount: rule?.MinOrderAmount || "", // NEW
          RewardType: rule?.RewardType || "1",
          IsActive: rule?.IsActive,
        });
      }
    } catch (err) {
      console.log("No existing rule or error:", err);
    }
    setDataLoading(false);
  };
  useEffect(() => {
    fetchRewardRule();
  }, [orgId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    const payload = {
      OrgId: parseInt(orgId),
      Name: formData.Name,
      StartFrom: formData.StartFrom ? `${formData.StartFrom}T00:00:00` : null,
      ExpiresOn: formData.ExpiresOn ? `${formData.ExpiresOn}T23:59:59` : null,
      RatePerAmount: parseInt(formData.RatePerAmount) || 0,
      RedeemValue: parseFloat(formData.RedeemValue) || 0,
      MinPoints: parseInt(formData.MinPoints) || 0,
      MaxRedeemPercent: parseInt(formData.MaxRedeemPercent),
      PointExpiryDays: parseInt(formData.PointExpiryDays) || 0,
      MinOrderAmount: parseFloat(formData.MinOrderAmount) || 0,
      RewardType: parseInt(formData.RewardType) || 1,
      IsActive: formData.IsActive || 1,
      CreatedBy: parseInt(userDataSession?.UserId),
      UpdatedBy: parseInt(userDataSession?.UserId),
    };

    try {
      await axios.post(`${API_BASE_URL}Settings/InsertRewardRules`, payload);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Reward rule saved successfully!",
      }).then(() => {
        fetchRewardRule();
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to save reward rule.",
      });
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchExemptedItems = async () => {
    if (!ruleId) {
      setExemptedItems([]);
      return;
    }
    setListLoading(true);
    try {
      const res = await axios.get(
        `${API_BASE_URL}Settings/getExemptedItems?RuleId=${ruleId}`,
      );
      if (res.data.Status) {
        setExemptedItems(res.data.ResultData || []);
      } else {
        setExemptedItems([]);
      }
    } catch (err) {
      console.error("Failed to load exempted items", err);
      setExemptedItems([]);
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    fetchExemptedItems();
  }, [ruleId]);
  console.log(listLoading, exemptedItems);

  const handleDelete = (id, itemName) => {
    Swal.fire({
      title: "Remove Exemption?",
      text: `"${itemName}" will earn rewards again.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.post(`${API_BASE_URL}Settings/DelExemptedItems`, {
            Id: id,
            RuleId: ruleId,
          });
          Swal.fire("Removed!", "The exemption has been removed.", "success");
          fetchExemptedItems();
        } catch (err) {
          Swal.fire("Error", "Failed to remove", "error");
        }
      }
    });
  };

  return (
    <>
      {(dataLoading || loading) && <SpinLoader />}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Rewards</h4>
                <h6>Manage Reward Points</h6>
              </div>
            </div>

            <div className="page-btn d-none">
              <Link
                to="#"
                className="btn btn-added true color"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasViewExemptedProducts"
                aria-controls="offcanvasViewExemptedProducts"
                title="View Exempted Products"
              >
                <Eye className="" />
              </Link>
            </div>
            <div className="page-btn import d-none">
              <Link
                to="#"
                className="btn btn-added primary"
                data-bs-toggle="modal"
                data-bs-target="#addExemptedProducts"
                aria-controls="addExemptedProducts"
                title="Add Exempted Products"
              >
                <PlusCircle className="iconsiz fs-2" />
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-8">
              <form onSubmit={handleSubmit}>
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <i className="fas fa-sliders-h me-2"></i>Reward Rules
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3 add-product">
                          <label className="form-label">
                            Name
                            <span className="fw-bold text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            name="Name"
                            value={formData?.Name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3 add-product">
                          <label className="form-label">
                            Start Date
                            <span className="fw-bold text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="StartFrom"
                            value={formData?.StartFrom}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3 add-product">
                          <label className="form-label">
                            End Date
                            <span className="fw-bold text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="ExpiresOn"
                            value={formData?.ExpiresOn}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 ">
                        <div className="mb-3 add-product">
                          <label className="form-label">Min Order Amount</label>
                          <input
                            type="number"
                            step="0.01"
                            className="form-control"
                            placeholder="e.g., 0 or 500 (leave 0 for no minimum)"
                            name="MinOrderAmount"
                            value={formData.MinOrderAmount}
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                          />
                          <span className="text-muted ">
                            (Points earned only if bill ≥ this amount. 0 =
                            always earn)
                          </span>
                        </div>
                      </div>

                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3 add-product">
                          <label className="form-label">
                            Rate Per Bill Amount
                            <span className="fw-bold text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Rate Per Amount"
                            name="RatePerAmount"
                            value={formData?.RatePerAmount}
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                            required
                          />
                        </div>
                        <span className="text-muted">
                          (e.g., For every ₹100 spent, 1 point is earned)
                        </span>
                      </div>

                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3 add-product">
                          <label className="form-label">
                            Redeem Value
                            <span className="fw-bold text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            step="0.01"
                            className="form-control"
                            placeholder="Enter Redeem Value"
                            name="RedeemValue"
                            value={formData.RedeemValue}
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                            required
                          />
                        </div>
                        <span className="text-muted ">
                          (e.g., 10 points = ₹1 discount)
                        </span>

                        {/* OR Dynamic live preview (uncomment if you want this instead) */}
                        {/* {formData.RedeemValue > 0 && (
      <span className="text-muted small d-block mt-1">
        {formData.RedeemValue} points = ₹{(formData.RedeemValue * 0.10).toFixed(2)} discount
      </span>
    )} */}
                      </div>

                      <div className="col-lg-4">
                        <div className="mb-3 add-product">
                          <label className="form-label">
                            Minimum Points
                            <span className="fw-bold text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Minimum Redeemable Points"
                            name="MinPoints"
                            value={formData.MinPoints}
                            onWheel={(e) => e.target.blur()}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <span className="text-muted">
                          (e.g., A Customer can Redeem points only after 4000
                          points)
                        </span>
                      </div>
                      <div className="col-lg-4">
                        <div className="mb-3 add-product">
                          <label className="form-label">
                            Max Redeem Percent
                            <span className="fw-bold text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            step="0.01"
                            className="form-control"
                            placeholder="Enter Max Redeem Percent"
                            name="MaxRedeemPercent"
                            value={formData.MaxRedeemPercent}
                            onWheel={(e) => e.target.blur()}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="mb-3 add-product">
                          <label className="form-label">
                            Point Expiry Days
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Expire days limit"
                            name="PointExpiryDays"
                            value={formData.PointExpiryDays}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12 d-none">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Reward Type{" "}
                              <span className="fw-bold text-danger">*</span>
                            </label>
                            <select
                              className="form-control form-select"
                              name="RewardType"
                              value={formData.RewardType}
                              onChange={handleChange}
                              required
                            >
                              <option value="1">Points-based (Default)</option>
                              {/* Add more types if you plan to support later */}
                              {/* <option value="2">Cashback</option> */}
                            </select>
                            <span className="text-muted small d-block mt-1">
                              (Currently only Points-based is supported)
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="text-end mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            {/* Right Side - Exempted Products (Untouched) */}
            <div className="col-4">
              <div className="card flex-fill">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div className="d-inline-flex align-items-center">
                    <span className="title-icon bg-soft-pink fs-16 me-2">
                      <i className="fas fa-exclamation-triangle"></i>
                    </span>
                    <h5 className="card-title mb-0">Exempted Category/Items</h5>
                  </div>
                  <Link
                    to="#"
                    className="btn btn-sm "
                    data-bs-toggle="modal"
                    data-bs-target="#addExemptedProducts"
                  >
                    <PlusCircle />
                  </Link>
                </div>

                <div
                  className="card-body sell-product"
                  style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    paddingRight: "8px",
                  }}
                >
                  {listLoading ? (
                    <p className="text-center text-muted">Loading...</p>
                  ) : exemptedItems.length === 0 ? (
                    <p className="text-center text-muted">
                      No items exempted yet
                    </p>
                  ) : (
                    exemptedItems.map((item) => {
                      const isCategory =
                        item?.ProductId === null &&
                        item?.ExemptionType === "Category";

                      const displayName = isCategory
                        ? item?.CategoryName
                        : item?.ItemName.length > 25
                          ? item?.ItemName.substring(0, 25) + "..."
                          : item?.ItemName;

                      const firstLetter = isCategory
                        ? item?.CategoryName.charAt(0).toUpperCase()
                        : item?.ItemName.charAt(0).toUpperCase();

                      const itemNameForDelete = isCategory
                        ? item?.CategoryName
                        : item?.ItemName;

                      return (
                        <div
                          key={item?.Id}
                          className={`d-flex align-items-center justify-content-between border-bottom pb-2 mb-2 ${
                            isCategory ? "category-item" : ""
                          }`}
                        >
                          <div className="d-flex align-items-center">
                            <div
                              className={`avatar avatar-md me-3 rounded d-flex align-items-center justify-content-center text-white fw-bold ${
                                isCategory ? "bg-primary" : "bg-secondary"
                              }`}
                              style={{
                                fontSize: "18px",
                                width: "40px",
                                height: "40px",
                              }}
                            >
                              {firstLetter}
                            </div>

                            <div>
                              <h6
                                className={`mb-1 title-truncate ${
                                  isCategory ? "fw-bold" : "fw-bold"
                                }`}
                                title={
                                  isCategory
                                    ? item?.CategoryName
                                    : item?.ItemName
                                }
                              >
                                {displayName}
                              </h6>
                              {isCategory ? (
                                <p className="text-muted small mb-0">
                                  <small>
                                    All Products under {item?.CategoryName}
                                  </small>
                                </p>
                              ) : (
                                <p className="text-muted small mb-0">
                                  {item?.CategoryName} • {item?.ExemptionType}
                                </p>
                              )}
                            </div>
                          </div>

                          <button
                            onClick={() =>
                              handleDelete(item?.Id, itemNameForDelete)
                            }
                            className="btn btn-sm text-danger"
                            title="Remove exemption"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddExemptedProducts />
      <ViewExemptedProducts />
    </>
  );
};

export default Rewards;
